import { userTypes } from "@/components/MyAccount/myaccount.constants";
import { commonEnvVariables } from "@/commonEnvVariables";

const envVariables = commonEnvVariables();

export const appCommonConstants = {
    RESIGN_FROM: 'Resign from ',
    LEAVE_COMMUNITY_CONF_MESSAGE: 'Are you sure you want to resign from the ',
    DELETE: 'Delete',
    SAVE: 'SAVE',
    SUBMIT: 'SUBMIT',
    CONTINUE: 'Continue',
    CREATE: 'Create',
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    PREVIEW: 'Preview',
    BACK: 'Back',
    REJECT: 'Reject',
    CONFIRM: 'Confirm',
    UPDATE: 'Update',
    HIDE: 'Hide',
    REMOVE: 'Remove',
    YES: 'YES',
    NO: 'NO',
    VIEW_ALL: 'View All',
    SEE_MORE: 'see more',
    EVENT_COUNT_MIN: 3,
    EVENT_COUNT_MIN_CHAMPS: 5,
    EVENT_COUNT_UNLIMITED: Number.MAX_VALUE,
    MANAGE_EVENT: 'MANAGE EVENT',
    MANAGE_EVENT_GOTO_LINK: `${process.env.VUE_APP_CVENT_URL}Overview/Overview/Index/View?evtstub=`,
    CREATE_NEW_EVENT: 'CREATE EVENT IN CVENT',
    CREATE_NEW_EVENT_GOTO_LINK: `${envVariables.CREATE_NEW_EVENT_UPDATED_URL}`,
    LESS: 'Less',
    MORE: 'More',
    ADD: 'Add',
    APPLY: 'Apply',
    DONE: 'DONE',
    FILE_ATTACHMENT_SIZE_LIMIT: 25 * (1024 * 1024), // 25MB
    MAXIMUM_NUMBER_OF_FILE_ATTACHMENTS: 10,
    MAXIMUM_NUMBER_OF_FILE_ATTACHMENTS_WAIVER: 6,
    IMAGE_FILE_TYPES_ACCEPTED: 'image/jpg,image/png,image/jpeg,image/gif',
    VIDEO_FILE_TYPES_ACCEPTED: 'video/mp4',
    IMAGE_FILE_TYPE_EXTENSIONS: 'jpg,jpeg,png,gif',
    VIDEO_FILE_TYPES_EXTENSIONS: 'mp4',
    SESSION_WARNING: "Your Session Will Expire In 30 Minutes",
    SESSION_EXPIRED_LABEL: "Your Session has expired",
    SEND: 'SEND',
    BACK_TO_TOP: 'Back to top',
    DEFAULT_SYSTEM_TEXT_COLOR: '#fff',
    DEFAULT_SYSTEM_BACKGROUND_COLOR: '#D69D23',
    PUBLIC: 'Public',
    SECRET: 'Secret',
    PRIVATE: 'Private',
    COMMENT: 'COMMENT',
    ONE: 1,
    OK: 'Ok',
    ADOBE_LMS_URL: `${process.env.VUE_APP_LMS_URL}`,
    SESSION_USER_WARNING: '<h3>For your security, your YPO Connect session remains active for a limited time before we ask you to confirm your identity by logging in again. Your current session will expire in 30 minutes.<br><br>No further action is needed. For login assistance, please contact us <a href="mailto:ask@ypo.org?">ask@ypo.org</a>.</h3>',
    SESSION_IDLE_TIMEOUT: `<h3>Your YPO Connect session has expired. For your security we are resetting your session.</h3>`,
};
export const menuOptions = {
    HOME: 'home',
    FORUM: 'forum',
    CHAPTER: 'chapter',
    NETWORK: 'network',
    REGION: 'region',
    CHAMPION: 'champion',
    GROUP: 'group',
    //  AROUND_ME: 'aroundMe',
    BUSINESSES: 'businesses',
};
export const menuDisplayNames = {
    menu: [
        { name: menuOptions.HOME, displayName: '' },
        { name: menuOptions.FORUM, displayName: 'forums' },
        { name: menuOptions.CHAPTER, displayName: 'chapters' },
        { name: menuOptions.NETWORK, displayName: 'networks' },
        { name: menuOptions.REGION, displayName: 'regions' },
        { name: menuOptions.CHAMPION, displayName: 'champions' },
        { name: menuOptions.GROUP, displayName: 'groups' },
        { name: menuOptions.BUSINESSES, displayName: '' },
       ],
    };
export const routerNames = {
    ...menuOptions,
    LAYOUT: 'Layout',
    PRIVACYSETTINGS: 'privacySettings',
    EMAILSETTINGS: 'emailSettings',
    MANAGELOGINSECURITY: 'loginSecurity',
    NOTIFICATIONS: 'notification',
    VISIBILITY: 'visibility',
    MYPROFILE: 'myProfile',
    MEMBERPROFILE: 'memberProfile',
    LOGIN: 'login',
    LOGOUT_SF: 'logoutSf',
    MEMBER_DIRECTORY_PAGE: 'memberDirectoryPage',
    EVENT_DIRECTORY_PAGE: 'eventDirectoryPage',
    YPO_EVENTS: 'events',
    EVENT_DIRECTORY: 'eventDirectory',
    CONTENT_DIRECTORY_PAGE: 'contentDirectoryPage',
    COMMUNITY_DIRECTORY_PAGE: 'communityDirectoryPage',
    MEMBER_CONNECTIONS: 'memberConnections',
    FOLLOWS: 'follows',
    SPEAKER: 'speakers',
    EDIT: 'edit',
    MESSENGER: 'messenger',
    RESETPASSWORD: 'ResetPassword',
    APP_VERSION: 'version',
    ERROR_PAGE: 'errorPage',
    LOGOUT: 'logout',
    ASSISTPAGE: 'AssistPage',
    CHAPTER_WAIVER: 'ChapterWaiver',
    PEER_REVIEW_PANEL_ADMIN: 'PeerReviewPanelAdmin',
    PEER_REVIEW_PANEL: 'PeerReviewPanel',
    EVENT_ATTENDEES: 'EventAttendees',
    REGIONAL_MEMBER_OFFICER: 'RegionalMemberOfficer',
    CHAPTER_EVENT: 'ChapterEvent',
    CHAMPS_EVENT: 'ChampsEvent',
    SPEAKER_ADMINSTRATION: 'speakerAdministration',
    SPEAKERPROFILE: 'speakerProfile',
    RESOURCEDIRECTORY: 'resourceDirectory',
    SEARCH_SPEAKERS: 'SearchSpeakers',
    EDIT_SPEAKER_PROFILE: 'editSpeakerProfile',
    POLICIES_PROCEDURES: 'policiesProcedures',
    YPO_SEARCH: 'ypoSearch',
    CHAMPS_PAGE: 'champs',
    CORONA_VIRUS: 'coronavirus',
    FORUM_EXERCISE: 'forumExercise',
    WAIVER_FORM: 'WaiverForm',
    WAIVER_FORM_PRP_ADMIN: 'WaiverFormPRPAdmin',
    UPDATE_BOOKMARK: 'updateBookmark',
    WAIVER_FORM_COMMON: 'WaiverFormCommon',
    AUTH_WITH_CONNECT: 'authConnect',
    CONCIERGE_PAGE: 'concierge',
    LMS_PAGE: 'lms',
    RESOURCE_MENU_PAGE: "resources",
    CHAPTER_MANAGEMENT: 'chaptermanagement',
    M2MX_PROFILE: 'm2mxprofile',
    RESET_PASSWORD_PAGE: 'pwreset',
    FORGOT_USER_NAME: 'Login | Recover Username',
    ALL_NETWORKS_PAGE: 'allNetworksPage',
    NETWORK_LANDING_PAGE: 'networkLandingPage',
    CHAPTER_STUDIO: 'chapterStudio',
    MANAGE_CHAPTER_STUDIO: 'manageAnnouncements',
    CREATE_ANNOUNCEMENT: 'createAnnouncement',
    COMMUNITIES: 'communities',
};

export const homeBanner = {
    ...menuOptions,
    CHAPTER_HEALTH: 'Chapter Health',
    PLATINUM: 'PLATINUM',
    MY: 'My',
    PLEASE_SELECT_YOUR_EMAIL_PREFERENCES: 'Please select your email preferences',
    SEND_ME_EMAIL_CORRESPONDENCE_ALERTS: 'SEND ME EMAIL CORRESPONDENCE ALERTS..',
    JOIN: 'Join ',
    APPLY_TO_JOIN: 'Apply to Join',
};

export const routesContainingMobileMenu = [
    menuOptions.HOME,
    menuOptions.CHAPTER,
    menuOptions.FORUM,
    menuOptions.CHAMPION,
    menuOptions.GROUP,
    menuOptions.NETWORK,
    menuOptions.REGION,
];

export const capitalize = (value) => {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
};

export const userRoles = {
    ADMIN: 'Admin View',
    MEMBER: 'Member View',
    //TODO: (Bishal) - removing this until Beta release if complete
    /* BETA: 'Beta View',*/
};
export const promiseHandler = promise =>
    promise.then(data => ({ ok: true, data })).catch(error => Promise.resolve({ ok: false, error }));

export const postTypes = {
    ALL_POSTS: 'All Post',
    PENDING_MODERATION: 'Pending Moderation',
};
export const roles = { ...userTypes };
